import geoAlert from 'services/utils/alert';

import sridList, { typeOptions } from './sridList';

export const initialToolOptionsState = {
  type: typeOptions[0],
  timezone: null,
  timezoneIsEnabled: false,
  savedData: [],
  savedDataRaw: [],
  actualData: {
    lng: null,
    lat: null,
  },
  separator: null,
  otheSeparator: '',
  latColumn: null,
  lngColumn: null,
  csvFile: null,
  csvRows: [],
  csvColumns: [],
  csvCoords: [],
};

// Esse reducer controla as opções de formulário que aparecem
const toolOptionsReducer = (state, action) => {
  switch (action.type) {
    case 'setType':
      if (
        action.payload &&
        (typeOptions.includes(action.payload) ||
          sridList.includes(action.payload))
      ) {
        return {
          ...state,
          type: action.payload,
          timezone: action.payload.value === 'UTM' ? state.timezone : null,
          timezoneIsEnabled: action.payload.value === 'UTM',
        };
      } else {
        throw new Error('Tipo de Coordenada inválida');
      }
    case 'setTimezone':
      return {
        ...state,
        timezone: action.payload,
      };
    case 'setLongitude':
      if (typeof action.payload.index !== 'undefined') {
        const savedData = state.savedData;
        savedData[action.payload.index] = {
          ...savedData[action.payload.index],
          lng: action.payload.lng,
        };
        return {
          ...state,
          savedData,
        };
      } else {
        return {
          ...state,
          actualData: {
            ...state.actualData,
            lng: action.payload,
          },
        };
      }
    case 'setLatitude':
      if (typeof action.payload.index !== 'undefined') {
        const savedData = state.savedData;
        savedData[action.payload.index] = {
          ...savedData[action.payload.index],
          lat: action.payload.lat,
        };
        return {
          ...state,
          savedData,
        };
      } else {
        return {
          ...state,
          actualData: {
            ...state.actualData,
            lat: action.payload,
          },
        };
      }
    case 'insertCoords': {
      if (
        (state.actualData.lng && state.actualData.lat) ||
        state.savedData.length
      ) {
        if (
          state.type.value === 'UTM' &&
          (state.timezone === null || state.timezone === '')
        ) {
          geoAlert({ message: 'Fuso é obrigatório!' });
          action.callback(false);
          return state;
        }

        let listOfCoords;
        // Verifica se os dados atuais devem entrar, isso acontecem se ambos os campos não estiverem vazios
        if (state.actualData.lng && state.actualData.lat) {
          listOfCoords = [...state.savedData, state.actualData];
        } else {
          listOfCoords = [...state.savedData];
        }

        listOfCoords.forEach((coords, index, array) => {
          array[index] = {
            ...coords,
            lat: coords.lat,
            lng: coords.lng,
            zone: coords.zone || state.timezone?.value || 24,
            projection: coords.projection || state.type.projection || 'WGS84',
            data: coords.data || null,
          };
        });

        action.callback(listOfCoords);

        return {
          ...state,
          savedData: [],
          actualData: {
            lat: '',
            lng: '',
          },
        };
      } else {
        geoAlert({ message: 'Coordenadas não preenchidas' });
        action.callback(false);
        return state;
      }
    }
    case 'addCoordsField':
      return {
        ...state,
        savedData: [...state.savedData, state.actualData],
        actualData: {
          ...state.actualData,
          lat: '',
          lng: '',
        },
      };
    case 'resetState': {
      return action?.payload?.all
        ? { ...initialToolOptionsState }
        : {
            ...initialToolOptionsState,
            type: state.type,
            timezone: state.timezone,
            timezoneIsEnabled: state.timezoneIsEnabled,
            csvCoords: state.csvCoords,
          };
    }
    case 'setSeparator': {

      let columns = []; 
      if (state.csvRows.length) { 
        columns = state.csvRows[0].split(action.payload.value); 
        columns = columns.map((c, i) => ({ label: c, index: i }));
        columns = columns.length > 1 ? columns : []; 
      }
      return {
        ...state, 
        separator: action.payload, 
        csvColumns: columns, 
        latColumn: null, 
        lngColumn: null,
      };
    }
    case 'setOtherSeparator': {
      let columns = [];
      if (state.csvRows.length && action.payload) {
        columns = state.csvRows[0].split(action.payload);
        columns = columns.map((c, i) => ({ label: c, index: i }));
        columns = columns.length > 1 ? columns : [];
      }
      return {
        ...state,
        otheSeparator: action.payload,
        csvColumns: columns,
        latColumn: null,
        lngColumn: null,
      };
    }
    case 'setLatColumn':
      return {
        ...state,
        latColumn: action.payload,
      };
    case 'setLngColumn':
      return {
        ...state,
        lngColumn: action.payload,
      };
    case 'setCsvFile':
      return {
        ...state,
        csvFile: action.payload,
      };
    case 'setCsvRows': {
      let columns = [];
      let separator =
        state.separator?.value === 'outro'
          ? state.otheSeparator
          : state.separator?.value;
      if (separator && action.payload.length) {
        columns = action.payload[0].split(separator);
        columns = columns.map((c, i) => ({ label: c, index: i }));
        columns = columns.length > 1 ? columns : [];
      }
      return {
        ...state,
        csvRows: action.payload,
        csvColumns: columns,
        latColumn: null,
        lngColumn: null,
      };
    }
    case 'importCsvCoords': {
      let coords = [];
      let error = '';
      let separator =
        state.separator?.value === 'outro'
          ? state.otheSeparator
          : state.separator?.value;
      if (
        state.csvRows &&
        separator &&
        state.type.projection &&
        state.latColumn &&
        state.lngColumn
      ) {
        state.csvRows.forEach((r, i) => {
          if (r && i > 0) {
            let rowString = r;
            // Removendo temporariamente valores entre aspas duplas
            let quotedColumns = rowString.match(/"(.*?)"/g) || [];
            quotedColumns.length &&
              quotedColumns.forEach(
                (qc, x) =>
                  (rowString = rowString.replace(qc, `quotedColumn${x}`))
              );
            let rowData = rowString.split(separator);
            // Reatribuindo os valores entre aspas duplas
            quotedColumns.length &&
              quotedColumns.forEach((qc, z) => {
                let rdIndex = rowData.findIndex(
                  (rd) => rd === `quotedColumn${z}`
                );
                if (rdIndex !== -1) {
                  rowData[rdIndex] = qc;
                }
              });
            if (
              rowData[state.latColumn.index] &&
              rowData[state.lngColumn.index] &&
              rowData.length === state.csvColumns.length
            ) {
              let rowObj = {};
              rowData.forEach(
                (rd, colunmIndex) =>
                  state.csvColumns[colunmIndex] &&
                  (rowObj[state.csvColumns[colunmIndex].label] = rd)
              );
              coords.push({
                lat: rowData[state.latColumn.index],
                lng: rowData[state.lngColumn.index],
                zone: state.timezone?.value || 24,
                projection: state.type.projection || 'WGS84',
                data: rowObj,
              });
            } else {
              error = 'Não foi possível inserir o arquivo. Arquivo incompleto.';
            }
          }
        });
        if (error) {
          geoAlert({
            message: error,
          });
          return state;
        }
        setTimeout(action?.callback, 100);
        return {
          ...state,
          csvCoords: [...state.csvCoords, ...coords],
          savedData: [...coords],
        };
      } else {
        geoAlert({ message: 'É necessário preencher todos os campos!' });
        return state;
      }
    }
    case 'restoreCsvCoords': {
      if (state.csvCoords.length) {
        action?.callback && setTimeout(action.callback, 100);
        return {
          ...state,
          savedData: [...state.csvCoords],
        };
      } else {
        geoAlert({ message: 'Não há coordenadas inseridas por CSV!' });
        return state;
      }
    }
    default:
      throw new Error();
  }
};

export default toolOptionsReducer;
